import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { ListingType } from './types'

interface ListingModeState {
  listingMode: ListingType
  setListingMode: (mode: ListingType) => void
}

export const useListingModeStore = create<ListingModeState>()(
  persist(
    (set) => ({
      listingMode: 'rent',
      setListingMode: (mode) => set({ listingMode: mode })
    }),
    {
      name: 'listing-mode-storage'
    }
  )
)
